import { IJob, Job } from '.';
import { Itinerary } from '../types';

export interface IRoute extends IJob {
    itineraryId: string;
    routeType: string;
    itinerary?: Itinerary;
}

interface Route extends IRoute {}

class Route extends Job {
    constructor(data: IRoute) {
        super(data);
        Object.assign(this, data);
    }
}

export { Route };
